import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

function AWS() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div className="page container">

       <Helmet>
        <title>AWS Data Security | realgeneric shop</title>
        <meta
          name="description"
          content="Learn how Realgenericshop uses Amazon Web Services (AWS) to protect your personal and medical data with encryption and compliance standards."
        />
        <meta name="keywords" content="aws security, realgenericshop, data protection, online pharmacy security" />
        <link rel="canonical" href="https://realgenericshop.com/aws-security" />
      </Helmet>

      <h1>Data Security with Amazon Web Services (AWS) – Trusted Cloud Security for Your Privacy</h1>

      <p>
        Amazon Web Services (AWS) is a global leader in cloud security and data protection,
        trusted by companies across more than 190 countries, including many Fortune 500 organizations.
      </p>

      <p>
        <b>Realgenericshop</b> uses AWS to safeguard your personal and medical information
        with advanced encryption and globally compliant infrastructure standards.
      </p>

      <h3>Why Realgenericshop Chooses AWS?</h3>

      <p>
        Along with providing affordable healthcare essentials, we ensure:
      </p>

      <ul>
        <li>Fast and secure processing powered by AWS reliability</li>
        <li>Encrypted storage of personal and payment information</li>
        <li>Compliance with HIPAA, GDPR, and global data protection standards</li>
        <li>24/7 system monitoring to prevent unauthorized access</li>
        <li>Secure backup and disaster recovery systems</li>
        <li>Enhanced privacy for sensitive medical orders</li>
      </ul>

      <h3>How AWS Protects Your Data</h3>

      <p>
        AWS uses a multi-layered security architecture to protect user data and transactions.
        It includes advanced hardware security modules (HSMs) that securely manage cryptographic keys
        without exposing them externally.
      </p>

      <p>
        AWS Payment Cryptography follows industry standards such as PCI DSS and supports
        encryption techniques like Point-to-Point Encryption (P2PE) and secure PIN processing
        to protect financial data during transactions.
      </p>

      <p>
        Additionally, AWS provides automated key management systems for key generation,
        rotation, and access control integrated with Identity and Access Management (IAM)
        for strict authorization control.
      </p>

      <p>
        Real-time monitoring tools like AWS CloudTrail and CloudWatch help detect
        unauthorized activity and ensure continuous security across all systems.
      </p>

      <h3>Customer Trust & Confidentiality Guaranteed</h3>

      <p>
        Your privacy is our top priority. Whether ordering medicines for general wellness
        or specific treatments, <b>Realgenericshop</b> ensures your data remains secure and confidential.
      </p>

      <p>
        We store only essential order-related data, and you may request data deletion at any time
        by contacting support@realgenericshop.com.
      </p>

      <h3>FAQs</h3>

      <h4>What is AWS security?</h4>
      <p>
        AWS provides enterprise-level cloud security, encryption, and monitoring systems
        to protect sensitive customer data.
      </p>

      <h4>Is my medical information safe with Realgenericshop?</h4>
      <p>
        Yes. All medical and personal information is securely stored using AWS infrastructure
        following global compliance standards such as HIPAA and GDPR.
      </p>

      <h4>How does AWS protect online transactions?</h4>
      <p>
        AWS ensures all transactions are encrypted and protected from cyber threats
        through advanced cloud security systems and monitoring tools.
      </p>

      <h4>Why is AWS important for online pharmacies?</h4>
      <p>
        AWS provides a secure and scalable infrastructure that ensures safe handling
        of medical and financial data, giving customers complete peace of mind.
      </p>

    </div>
  );
}

export default AWS;